import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import { get, keyBy, map, some } from 'lodash'
import PageSectionList from '../../../../shared/components/layouts/PageSectionList'

const IngressesSection = ({ ingresses, domains, ingressControllers, onCreateClick, onEditClick, onDeleteClick }) => {
  const domainsById = keyBy(domains, 'id')
  const ingressControllersById = keyBy(ingressControllers, 'id')

  const renderItem = useCallback((ingress) => {
    const domainIds = ingress.domainIds || []
    const domainNames = map(domainIds, (id) => {
      const domain = get(domainsById, id)
      return get(domain, 'domain', 'Unknown')
    })
    const hasPendingDomain = some(domainIds, (id) => {
      const domain = get(domainsById, id)
      return get(domain, 'status') === 'pending'
    })
    const ingressController = get(ingressControllersById, ingress.ingressControllerId)
    const ingressControllerName = get(ingressController, 'name', 'Unknown')

    return {
      primary: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body1">{domainNames.join(', ')}{ingress.path}</Typography>
          {hasPendingDomain && (
            <Chip
              label={<FormattedMessage id="domains.status.pending" />}
              size="small"
              color="warning"
            />
          )}
        </Box>
      ),
      secondary: (
        <Typography variant="caption" color="text.secondary">
          <FormattedMessage id="ingresses.ingressControllerLabel" />: {ingressControllerName}
        </Typography>
      )
    }
  }, [domainsById, ingressControllersById])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={onCreateClick}
        >
          <FormattedMessage id="ingresses.createButton" />
        </Button>
      </Box>
      <PageSectionList
        items={ingresses}
        emptyId="ingresses.empty"
        renderItem={renderItem}
        onItemEdit={onEditClick}
        onItemDelete={onDeleteClick}
      />
    </>
  )
}

export default IngressesSection
